import React from 'react';
import { createRoot } from 'react-dom/client';
import 'src/polyfills';
import App from 'src/App';
import reportWebVitals from 'src/reportWebVitals';
import { ThemeProvider } from 'styled-components';
import { defaultTheme, GlobalStyle } from 'src/utils/styles';
import { ReactQueryProvider } from 'src/utils/react-query';
import { AuthProvider } from 'src/utils/auth';

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);
root.render(
    <ReactQueryProvider>
        <AuthProvider>
            <ThemeProvider theme={defaultTheme}>
                <App />
                <GlobalStyle />
            </ThemeProvider>
        </AuthProvider>
    </ReactQueryProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
